// src/pages/admin/StoreManagement.jsx
import React from 'react';
import PageBackground from '../../components/PageBackground';
import RequireRole from '../../components/RequireRole';
import StoreManagement from '../../components/StoreManagement';

const storeBg = "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1500&q=80";

export default function StoreManagementPage() {
  return (
    <RequireRole rolesAllowed={['admin', 'cooperative_store_manager', 'member_store_manager', 'establishment_store_manager']}>
      <PageBackground
        image={storeBg}
        boxed={false}
        overlayClass="bg-white/90 backdrop-blur"
        className="px-4 md:px-6"
        edgeToEdge={true}
      >
        <div className="mx-auto max-w-7xl py-6">
          <StoreManagement />
        </div>
      </PageBackground>
    </RequireRole>
  );
}
